var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function Accordion(el) {
  var $el = $(el);

  $el.find('.accordion__item-title').not('[data-accordion-init="1"]').on('click', toggleActive).attr('data-accordion-init', 1);

  function toggleActive() {
    var $item = $(this).closest('.accordion__item'),
      afterContent = getComputedStyle($item[0], ':after').content;

    if (afterContent.indexOf('accordion-disabled') === -1) {
      $item.toggleClass('js-accordion-active');
      $(this).attr('aria-expanded', $item.hasClass('js-accordion-active'));
      $item.children('.accordion__item-content').slideToggle({
        progress: function() {
          $item.trigger('accordion.slideProgress');
        }
      });
    }
  }
}

module.exports = Accordion;
